module.exports = __webpack_public_path__ + "img/microsoft.ea30239c.svg";